import "core-js/modules/es.array.push.js";
export default {
  data() {
    return {
      messages: [],
      ws: null
    };
  },
  mounted() {
    console.log("尝试连接 WebSocket...");

    // 创建 WebSocket 连接
    this.ws = new WebSocket("ws://147.8.151.214:1013/ws/monitor");

    // 连接打开时
    this.ws.onopen = () => {
      console.log("WebSocket 连接成功");
      this.addMessage({
        type: "system",
        message: "连接成功，等待数据推送...",
        timestamp: new Date().toLocaleTimeString()
      });
    };

    // 收到消息时
    this.ws.onmessage = event => {
      try {
        const data = JSON.parse(event.data);
        console.log("收到消息:", data);
        this.addMessage(data);
      } catch (e) {
        console.error("解析消息失败:", e);
        this.addMessage({
          type: "error",
          message: "原始消息: " + event.data,
          timestamp: new Date().toLocaleTimeString()
        });
      }
    };

    // 连接关闭时
    this.ws.onclose = () => {
      console.log("WebSocket 连接关闭");
      this.addMessage({
        type: "system",
        message: "连接已断开",
        timestamp: new Date().toLocaleTimeString()
      });
    };

    // 发生错误时
    this.ws.onerror = error => {
      console.error("WebSocket 错误:", error);
      this.addMessage({
        type: "error",
        message: `连接出错: ${error.message}`,
        timestamp: new Date().toLocaleTimeString()
      });
    };
  },
  beforeUnmount() {
    if (this.ws) {
      this.ws.close();
      console.log("WebSocket 已手动关闭");
    }
  },
  methods: {
    addMessage(msg) {
      this.messages.push({
        ...msg,
        timestamp: msg.timestamp || new Date().toLocaleTimeString()
      });
    }
  }
};